exports = module.exports = require("../../node_modules/@vue/cli-service/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".login__logo {\n  width: 100%;\n  max-width: 640px;\n  margin-bottom: 48px;\n}\n.login__form {\n  text-align: center;\n  margin: 0 auto;\n}\n", ""]);

// exports
